// extracted by mini-css-extract-plugin
export default {"breadcrumb":"src-pages-SalesCannelVersion-SalesChannelPromotionTag-css-module__breadcrumb--hFTOV"};